import DataRoomDocList from './DataRoomDocList.component';

export default DataRoomDocList;